import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { SentencesService } from '../service';
import {
	addSentence,
	addSentenceFailure,
	addSentenceSuccess,
	deleteSentence,
	deleteSentenceFailure,
	deleteSentenceSuccess,
	getSentenceToUpdate,
	getSentenceToUpdateFailure,
	getSentenceToUpdateSuccess,
	getSentences,
	getSentencesFailure,
	getSentencesSuccess,
	searchSentences,
	searchSentencesByPreviousLessons,
	setSearchSentencesAutoCompleteResult,
	setSearchSentencesByPreviousLessonsAutoComplete,
	updateSentence,
	updateSentenceFailure,
	updateSentenceSuccess,
} from './slice';

function* getSentencesListHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SentencesService(globalApplicationContext);
		const data = yield sentenceService.getSentences(
			action.payload.page,
			action.payload,
		);
		yield put(getSentencesSuccess(data));
	} catch (e) {
		yield put(getSentencesFailure(e));
		console.error(e);
	}
}

function* searchSentencesHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SentencesService(globalApplicationContext);
		const data = yield sentenceService.searchSentencesAutoComplete(
			action.payload,
		);
		yield put(setSearchSentencesAutoCompleteResult(data));
	} catch (e) {
		console.error(e);
	}
}

function* searchSentencesByPreviousLessonsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SentencesService(globalApplicationContext);
		const data = yield sentenceService.searchByPreviousLessonsAutoComplete(
			action.payload,
		);
		yield put(setSearchSentencesByPreviousLessonsAutoComplete(data));
	} catch (e) {
		console.error(e);
	}
}

function* deleteSentenceHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SentencesService(globalApplicationContext);
		yield sentenceService.deleteSentence(action.payload.sentenceId);
		yield put(deleteSentenceSuccess({}));
		toast('Sentence deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteSentenceFailure(e));
		console.error(e);
	}
}

function* addSentenceHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SentencesService(globalApplicationContext);
		yield sentenceService.addSentence(action.payload);
		yield put(addSentenceSuccess({}));
		toast('Sentence created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(addSentenceFailure({}));
	}
}

function* getSentenceToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SentencesService(globalApplicationContext);
		const data = yield sentenceService.getSentenceById(
			action.payload.sentenceId,
		);
		yield put(getSentenceToUpdateSuccess(data));
	} catch (e) {
		yield put(getSentenceToUpdateFailure({}));
	}
}

function* updateSentenceHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SentencesService(globalApplicationContext);
		yield sentenceService.updateSentence(action.payload);
		yield put(updateSentenceSuccess({}));
		toast('Sentence updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateSentenceFailure({}));
	}
}

export function* sentencesSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getSentences, getSentencesListHandler),
		takeEvery(deleteSentence, deleteSentenceHandler),
		takeEvery(addSentence, addSentenceHandler),
		takeEvery(getSentenceToUpdate, getSentenceToUpdateHandler),
		takeEvery(updateSentence, updateSentenceHandler),
		takeEvery(searchSentences, searchSentencesHandler),
		takeEvery(
			searchSentencesByPreviousLessons,
			searchSentencesByPreviousLessonsHandler,
		),
	]);
}
